"use client";
import React from "react";
import { PromptForm } from "../PromptForm";

interface ExpandedMenuProps {
  bubblePosition: { top: number; left: number };
  userPrompt: string;
  setUserPrompt: (prompt: string) => void;
  onSubmitPrompt: (e: React.FormEvent) => void;
  selectedElements: HTMLElement[];
  selectedElementsCount: number;
  isDarkMode: boolean;
}

export const ExpandedMenu: React.FC<ExpandedMenuProps> = ({
  bubblePosition,
  setUserPrompt,
  onSubmitPrompt,
  selectedElements,
}) => {
  return (
    <div
      className={`element-inspector-menu fixed z-[10000] w-[350px] overflow-y-auto rounded-xl bg-white p-4 shadow-lg`}
      style={{ top: bubblePosition.top, left: bubblePosition.left }}
    >
      <PromptForm
        setUserPrompt={setUserPrompt}
        handlePromptSubmit={onSubmitPrompt}
        selectedElements={selectedElements}
      />
    </div>
  );
};
